module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowPage"
  }, [_c('div', {
    staticClass: "title-acknowPage"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781429919197_toc01#toctitle1",
      "id": "title1"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("acknowledgments")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Thanks to Leslie Daniels, the best agent (and friend) a nervous (neurotic?) and superstitious (psycho?) writer could have. Thanks also to Elizabeth Beier, my fabulous editor and the only person I know who can actually use “fabulous” in a spoken sentence without sounding weird—"), _c('em', {
    staticClass: "i"
  }, [_vm._v("Oops, we did it again, ooh baby bay-buh!")]), _vm._v(" Hugs and thanks to Matthew Shear, cheery master of the paperback universe; Matthew Baldacci, sickeningly fit master of the marketing universe; and John Murphy, cynical king of the hell that is the public relations universe. Thanks to artmaster Michael Storrings for the sexy, savvy covers that put books in hands. Finally, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("un montón de")]), _vm._v(" thanks to Sally Richardson, brilliant and benevolent queen of the entire wacky (in a "), _c('em', {
    staticClass: "i"
  }, [_vm._v("good")]), _vm._v(" way, honest!) universe according to Saint Martin. Thanks too to the Albuquerque Fire Department girls, for letting me hang around the station. You ladies rock!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e86fe22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429919197_ack01.vue
// module id = 66
// module chunks = 0